import {useState, memo, MouseEvent} from 'react';
import {TableHeader, Popover, PopoverContent, DataTableHeader, DataTableSortState} from '@carbon/react';
import {Filter as FilterIcon} from '@carbon/icons-react';

export interface TableHeaderViewProps {
    header: DataTableHeader;
    headerProps: {
        [key: string]: unknown;
        isSortable: boolean | undefined;
        isSortHeader: boolean;
        key: string;
        onClick: (e: MouseEvent) => void;
        sortDirection: DataTableSortState;
    };
    onFilter: ((key: string) => void) | undefined;
}

export const TableHeaderView = memo(({header, headerProps, onFilter}: TableHeaderViewProps) => {
    const [popoverOpen, setPopoverOpen] = useState(false);
    const headerOnClick = headerProps.onClick as any;

    return <Popover open={popoverOpen} key={header.key} isTabTip className={`!z-50 w-full border-separate header-popover-container`} onMouseEnter={() => setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)} >
        <TableHeader {...headerProps} onClick={headerOnClick} key={header.key} className={`px-3 py-2 whitespace-nowrap overflow-hidden overflow-ellipsis text-sm w-full !flex`}>
            {header.header}
        </TableHeader>
        <PopoverContent className='header-popover-content'>
            <div className='text-background-gray-700 divide-y bg-white'>
                <div className='hover:bg-background-gray-200 px-4 py-2 hover:cursor-pointer flex hover:text-background-gray-800' onClick={() => onFilter && onFilter(header.key)} data-testid="filter-icon">
                    <FilterIcon />
                    <div className='ml-1'>Filter</div>
                </div>
            </div>
        </PopoverContent>
    </Popover>;
});

TableHeaderView.displayName = 'TableHeaderView';
